import { _, api, ts } from '_core';

export const getJobsApi = (userId: number) =>
  api.jobs.search({
    limit: 50,
    offset: 0,
    query: [
      '$and',
      ['type', '=', 'master_job'],
      ['item_type', 'IN', ['resource_analysis']],
      ['created_by_id', '=', userId],
    ],
    include: 'started_at,completed_at,error,item_id_ref,item_type,progress,warnings',
    order_by: [{ column: 'created_at', sort: 'desc' }],
  });

export const consolidateJobs = async (jobsList: ts.types.job.DraftJob[], resources: ts.StoreState['resources']) => {
  const uniqJobs = _.uniqBy(jobsList, (job) => job.item_type + job.item_id_ref);
  // get analysis info
  const combinedQuery = {
    resource_analyses: { get: [] as { id: number; include?: string }[] },
  };

  uniqJobs.forEach((job) => {
    combinedQuery.resource_analyses.get.push({
      id: Number(job.item_id_ref),
      include: 'id,name,item_id_ref,item_type',
    });
  });

  const combinedRes = await api.combined.run(combinedQuery);

  const jobsFinal = uniqJobs.map((job) => {
    let analysis = combinedRes.resource_analyses.get.find(
      (req: { data: { id: number } }) => req?.data?.id == Number(job.item_id_ref)
    )?.data;

    // Now, since item_type and item_id are available directly on the analysis,
    // we can use them to find the correct resource more simply.
    let resource;
    if (analysis?.item_type && analysis?.item_id_ref) {
      switch (analysis.item_type) {
        case 'universe':
          resource = resources.universes.find((u) => u.id == analysis.item_id_ref);
          break;
        case 'signal_dataset': {
          const signalDataset = resources.signal_datasets.find((sd) => sd.id == analysis.item_id_ref) as
            | ts.types.signal.Dataset
            | undefined;
          resource = signalDataset ? resources.signals.find((s) => s.id == signalDataset.signal_id) : undefined;
          break;
        }
        case 'signal_set':
          resource = resources.signal_sets.find((ss) => ss.id == analysis.item_id_ref);
          break;
        case 'backtest':
          resource = resources.backtests.find((b) => b.id == analysis.item_id_ref);
          break;
        case 'backtest_set':
          resource = resources.backtest_sets.find((bs) => bs.id == analysis.item_id_ref);
          break;
        case 'general_analysis':
          resource = resources.general_analyses.find((ga) => ga.id == analysis.item_id_ref);
          break;
        case 'risk_model':
          resource = resources.risk_models.find((rm) => rm.id == analysis.item_id_ref);
          break;
        case 'basket':
          resource = resources.baskets.find((b) => b.id == analysis.item_id_ref);
          break;
        case 'time_series':
          resource = resources.time_series.find((ts) => ts.id == analysis.item_id_ref);
          break;
        default:
          resource = undefined;
      }
      analysis = {
        ...analysis,
        resource,
      };
    }

    return { ...job, analysis };
  });

  return jobsFinal.filter((job) => !_.isEmpty(job.analysis?.resource));
};
